export default __webpack_public_path__ + "static/bw-logo-dcb2538a7b7e7f0128b7e4e085be21b9.svg";